import React from "react";
import _ from "lodash";
import XText from "./XText";
import XDiv from "./XDiv";

/**
 * @typedef {import("./XDiv").xdivparams} xdivparams
 * 
 * @typedef {Object} hstackparamsex
 * @property {any} children
 * @property {Number} spacing
 * @property {"[" | "|" | "]"} HAlign
 * @property {"^" | "-" | "_"} VAlign
 * 
 * @typedef {hstackparamsex & xdivparams} hstackparams
 * 
 * @param {hstackparams} param0
 */
function HStack({
  children = null,
  spacing = 0, 
  HAlign = undefined,
  VAlign = undefined,
  ...others}){

  function renderChildren(_c){
    if(React.isValidElement(_c)){
      return React.cloneElement(_c, 
        {
          ..._c.props, 
          style: {
            marginRight: _c.props.margin 
            || _c.props.marginRight 
            || (_c.props.style && _c.props.style.marginRight) 
            || spacing,
            ..._c.props.style,
          }
        });
    }else{
      return _.map(_c, (o, i) => {
        if(!o){
          return null;
        }else if(_.isArray(o)){
          return _.map(o, (v, x) => {
            return renderChildren(v);
          });
        }else if(_.isString(o)){
          return <XText key={i}>{o}</XText>;
        }else if(!React.isValidElement(o)){
          console.log(o);
          //return o;
        }else if(i === _c.length - 1 || !o.props || !spacing){
          return React.cloneElement(o, {...o.props, key: i});
        }else{
          return React.cloneElement(o, 
            {
              ...o.props, 
              key: i, 
              style: {
                marginRight: o.props.margin 
                || o.props.marginRight 
                || (o.props.style && o.props.style.marginRight) 
                || spacing,
                ...o.props.style,
              }
            });
        }
      });
    }
  }

  let _justifyContent = "center";
  let _alignItems = "center";

  switch(HAlign){
    case "[": _justifyContent = "flex-start"; break;
    default: case "|": _justifyContent = "center"; break;
    case "]": _justifyContent = "flex-end"; break;
  }

  switch(VAlign){
    case "^": _alignItems = "flex-start"; break;
    default: case "-": _alignItems = "center"; break;
    case "_": _alignItems = "flex-end"; break;
  }

  return (
    <XDiv
      display="flex"
      flexDirection="row"
      alignItems={_alignItems}
      justifyContent={_justifyContent}
      {...others}>
      {renderChildren(children)}
    </XDiv>
  );
}

export default HStack;